module.exports = __webpack_public_path__ + "img/TELA - 02 - ASSINATURA.49fe8b4a.png";